import { isNativeApp } from "./native.js";

const RELEASES_ENDPOINT = "https://notes.cctc.ai/api/releases/latest";
const isAndroid = /Android/i.test(navigator.userAgent);
let pendingDesktopUpdate = null;
let pendingRelease = null;

export async function getCurrentAppVersion() {
  if (!isNativeApp) return __APP_VERSION__;
  const { getVersion } = await import("@tauri-apps/api/app");
  return getVersion();
}

export function compareVersions(left, right) {
  const parse = (value) =>
    String(value)
      .replace(/^v/i, "")
      .split("-")[0]
      .split(".")
      .map((part) => Number.parseInt(part, 10) || 0);
  const leftParts = parse(left);
  const rightParts = parse(right);
  const length = Math.max(leftParts.length, rightParts.length);
  for (let index = 0; index < length; index += 1) {
    const difference = (leftParts[index] || 0) - (rightParts[index] || 0);
    if (difference) return Math.sign(difference);
  }
  return 0;
}

async function fetchLatestRelease() {
  const response = await fetch(RELEASES_ENDPOINT, {
    cache: "no-store",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error(`版本服务暂时不可用（${response.status}）`);
  return response.json();
}

export async function checkForAppUpdate() {
  const currentVersion = await getCurrentAppVersion();
  if (!isNativeApp) {
    return { available: false, currentVersion, reason: "web" };
  }

  if (isAndroid) {
    const release = await fetchLatestRelease();
    const android = release.platforms?.androidArm64;
    const available = Boolean(android?.url) && compareVersions(release.version, currentVersion) > 0;
    pendingRelease = available ? { ...release, platform: android } : null;
    return {
      available,
      currentVersion,
      version: release.version,
      notes: release.notes || "",
      platform: "android",
    };
  }

  const { check } = await import("@tauri-apps/plugin-updater");
  const update = await check({ timeout: 20_000 });
  pendingDesktopUpdate = update || null;
  return {
    available: Boolean(update),
    currentVersion,
    version: update?.version || currentVersion,
    notes: update?.body || "",
    platform: "macos",
  };
}

export async function installAppUpdate(onProgress = () => {}) {
  if (isAndroid) {
    if (!pendingRelease?.platform?.url) throw new Error("请先检查更新");
    const { openUrl } = await import("@tauri-apps/plugin-opener");
    await openUrl(pendingRelease.platform.url);
    return { requiresSystemConfirmation: true };
  }

  if (!pendingDesktopUpdate) throw new Error("请先检查更新");
  let downloaded = 0;
  let total = 0;
  await pendingDesktopUpdate.downloadAndInstall((event) => {
    if (event.event === "Started") total = event.data.contentLength || 0;
    if (event.event === "Progress") downloaded += event.data.chunkLength;
    onProgress({ event: event.event, downloaded, total });
  });
  const { relaunch } = await import("@tauri-apps/plugin-process");
  await relaunch();
  return { requiresSystemConfirmation: false };
}
